import { constructionSafety, logisticsAsset, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: 'Bạn có bao giờ tự hỏi làm thế nào điện thoại của bạn có thể kết nối liền mạch với xe hơi, hay tại sao các thiết bị thông minh có thể xác định vị trí của bạn chính xác đến từng centimet? Câu trả lời nằm ở một công nghệ tiên tiến mang tên UWB (Ultra-Wideband). Trong bài viết này, chúng ta sẽ cùng tìm hiểu UWB là gì, những ứng dụng tuyệt vời của nó, và cách nó hoạt động. Hãy cùng ORBRO bắt đầu nhé!',
  keywords: 'uwb, uwb là gì, ultra wideband, băng thông siêu rộng, ứng dụng uwb',
  ogSite: 'UWB là gì? Công dụng và nguyên lý hoạt động',
  title: 'UWB là gì? Công dụng và nguyên lý hoạt động',
  ogUrl: 'https://orbro.io/vi/blog/uwb-la-gi',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_Fncr-qLZRD6vBPG2d48XUaLfuV9Da6ll3NDMcWVLph05cw-AwXu2bZ5LEv6Ok6wgdxBqw5iTLcQ9T_t9kX9-YW-z2hTCABBaUejAZ6oazfAKTz9IAgkcE3i30IzMDJQNdXL60No85aD-NlEZrKKSbMUW-A8S8dYvTGrXHUcA4-XdWBZCxMPCSkyJ-OkVX2yv1sqJs7GFXBs1l2_OTyKHtD1WhnP5JG2n2bHGbbo-8F04-IjKrlz6mzzc2qPNTKaURcHY-t5hezrPE1S4Urm7Ks0l4WOAREqa9RoO4eH1GViGqXRHeB3KNNZqDzWdHX8izE9XI9y3WSKiQcWRsP-FrX4NlkThGSWmYqbSitMLXFqzXOlcZWXrtsa8fa5AqL-Exl3Q7BkYJRQT4R10BFeZ5jX18AuGkqZqUC7HFkS6x6uSkq55V8qdaPXl9oN8OFRMXEZR7WnsvYKq0HXVYRJG_9oLejUdkQUkrLnA1ZRCdeCXpwP3vdnyUnrxNWqO1SBA_J_YudlxOErvZH7b-0pGSG8n88_7_4iQhPvBZGwG1l7rTsZ8-CZkHEtTdAUih8XSfVnNbf5t9Y02mhkD_A8HCcmhE18qE7BhgnAdOnzwQqhTMAB3GDZkML3wOAL8uT-y_yMrSEAqYdvYVJ7AIYnjglB_sQGfu8EskoAWTJEjssbCacV8pXljW1oTIW1w_e66mo8eopX9kt0XU_Os9Sj-D3Wqa3377NageriKjdChXtaD0yqEOsn2MpA1ql8xKsclvMsXB2vxk3wVLKJlJuCn7fST-83-2u-n4aTITf8Njzj1wkeWxM4U6C__Vn6DoMzaGYeO1sI8HCsyflgFNB-Yl3JAWnAd-5rjb6EW7veNfUJmzXjxlQyuceh-piEX38DOXwKV9PI1WfM62dnhi6gKTkRC1tHkKI-5UDZkOm7YmPJI4j7kgCwFaFzpoLPVFDAlsDhaU53m4_06_cFN0kAICrD75q0mqYO9kuKZo0PTSyZhsUdoDrVR7HdPbGnU3NupmSDXIIVNiKXg_FduUc_TJ8j_fn8N59hD2FAqdyk9n0qTW7ac8XEYBq9iKTaYPcfx8-xkyQXd2rfe5o9mx8AAgYGyUA9Yo6Ohnvv-Vk3sHmJBn8Uukl05tf8eHXlWe6PXc25oOwE0wVBqgsfdGipHjOsPiTsr-apf3Rtz0puCZy2X6LooMhqHs5DSOCtm1mOeeOwuDkkG3IC8Gnm6pSNsVL1hxQ8w7bcfKd9STyEcN1BkDtL1cl136-0PjKaQ8DkrJMCpdNiXwx8gghSzRFbyJHYKv1-9MjZFB9oi4nsGDujo_cLqS3C4Ei6t-Fse8BlHYt_Lf8w722BKH4yQ08IE37EhR8epOH_Qa3Wi8OMIQ8SWZ7rwrbs6-96YzWz2DADJIkwDzcC6rdbrOp0gYGO0vI56x0-Zh8AzolkbRAzBZntTDEK2cGi0kObtYwhzUDnpwSfhuHKn4SHZb9vFMFh1qL41Ito-NUasQHP71-3SBM6Omk0l9m-iqHqTATcg-GJYKaxx4ieUVlvFRsQQnTor9AGYyPOhNMgzloMEL34rnJWKL5LdUhLxfeGaxp2NE4v1sLDX1M89MsuyRDPNS8m_8nL-HuV5x4YLAq5g=w1430-h1412?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-08',
  tag1: '#uwb',
  tag2: '#ultrawideband',
  tag3: '#ai',
  tag4: '#iot',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Bạn có bao giờ tự hỏi làm thế nào điện thoại của bạn có thể kết nối liền mạch với xe hơi, hay tại sao các thiết bị thông minh có thể xác định vị trí của bạn chính xác đến từng centimet? Câu trả lời nằm ở một công nghệ tiên tiến mang tên UWB (Ultra-Wideband). Trong bài viết này, chúng ta sẽ cùng tìm hiểu UWB là gì, những ứng dụng tuyệt vời của nó, và cách nó hoạt động. Hãy cùng ORBRO bắt đầu nhé!',
      dot: ''
    },
    {
      head: '1. UWB là gì?',
      subHead: '',
      desc: 'UWB, hay Băng thông siêu rộng, là một công nghệ truyền thông không dây sử dụng dải tần số rộng để gửi dữ liệu qua khoảng cách ngắn với độ chính xác cao. Không giống Wi-Fi hay Bluetooth, UWB nổi bật nhờ khả năng định vị siêu chính xác và hoạt động hiệu quả trong môi trường phức tạp, nơi các công nghệ khác có thể bị nhiễu hoặc yếu đi.\n\nCông nghệ UWB được ứng dụng trong nhiều thiết bị hiện đại như điện thoại thông minh, xe hơi, và hệ thống nhà thông minh, mang lại trải nghiệm kết nối nhanh chóng và an toàn hơn bao giờ hết.\n\nVí dụ: Khi bạn đứng gần xe hơi, chìa khóa thông minh dùng UWB sẽ tự động mở khóa mà không cần bấm nút – tất cả nhờ khả năng đo khoảng cách chính xác.',
      dot: ''
    },
    {
      head: '2. Nguyên lý hoạt động của UWB',
      subHead: '',
      desc: 'Vậy UWB hoạt động như thế nào? Dưới đây là cách công nghệ này vận hành:\n\n• Xung radio ngắn: UWB phát ra các xung sóng radio rất ngắn, trải rộng trên một dải tần số lớn (thường từ 500 MHz trở lên), thay vì tín hiệu liên tục như các công nghệ khác.\n\n• Đo thời gian bay (Time of Flight): Nó tính toán thời gian mà xung sóng di chuyển giữa hai thiết bị để xác định khoảng cách chính xác.\n\n• Định vị chính xác: Kết hợp nhiều điểm tham chiếu, UWB có thể xác định vị trí 3D của một vật thể với sai số chỉ vài centimet.\n\n• Kháng nhiễu: Nhờ sử dụng dải tần rộng, UWB ít bị ảnh hưởng bởi nhiễu sóng và có thể xuyên qua vật cản như tường hay kim loại.\n\nVí dụ: Trong một căn nhà, UWB có thể xác định chính xác bạn đang ở phòng nào, ngay cả khi có nhiều thiết bị điện tử hoạt động cùng lúc.',
      dot: ''
    },
    {
      head: '3. Công dụng của UWB',
      subHead: '',
      desc: 'UWB không chỉ tốt trong việc định vị mà còn có vô số ứng dụng thực tế trong cuộc sống. Dưới đây là một số công dụng nổi bật của UWB như:',
      dot: ''
    },
    {
      head: '',
      subHead: 'Định vị trong nhà',
      desc: 'Ứng dụng: Theo dõi vị trí người hoặc vật trong không gian kín như nhà kho, trung tâm thương mại.\nVí dụ: Bạn dùng ứng dụng bản đồ trong siêu thị để tìm quầy hàng yêu thích nhờ UWB.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Kết nối thiết bị thông minh',
      desc: 'Ứng dụng: Kết nối nhanh chóng giữa điện thoại, tai nghe, hoặc loa thông minh.\nVí dụ: Điện thoại của bạn tự động phát nhạc qua loa khi bạn bước vào phòng, nhờ UWB.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Chìa khóa không chạm',
      desc: 'Ứng dụng: Mở khóa xe hơi hoặc cửa nhà dựa trên vị trí của bạn.\nVí dụ: Xe Tesla dùng UWB để mở cửa tự động khi bạn đến gần.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Theo dõi tài sản',
      desc: 'Ứng dụng: Quản lý hàng hóa trong kho hoặc tìm đồ thất lạc.\nVí dụ: Apple AirTag dùng UWB để giúp bạn tìm chìa khóa bị mất với độ chính xác cao.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Ứng dụng trong y tế',
      desc: 'Ứng dụng: Theo dõi thiết bị y tế hoặc giám sát bệnh nhân.\nVí dụ: Bệnh viện dùng UWB để biết chính xác vị trí của máy đo nhịp tim.',
      dot: ''
    },
    {
      head: '4. Tại sao UWB đặc biệt?',
      subHead: '',
      desc: 'So với Bluetooth hay Wi-Fi, UWB có những ưu điểm vượt trội như:\n\n• Chính xác hơn: Định vị sai số chỉ 10-30 cm, trong khi GPS thường là 5-10 mét.\n\n• Ít nhiễu: Hoạt động tốt trong môi trường đông đúc.\n\n• Tiết kiệm năng lượng: Phù hợp cho thiết bị nhỏ như đồng hồ thông minh.\n\n• Bảo mật cao: Khó bị hack nhờ xung ngắn và mã hóa phức tạp.',
      dot: ''
    },
    {
      head: '5. Kết luận',
      subHead: '',
      desc: 'UWB là một bước tiến lớn trong công nghệ không dây, mang đến sự chính xác, tiện lợi và bảo mật mà các công nghệ khác khó sánh bằng. Từ mở khóa xe hơi, tìm đồ thất lạc, đến kết nối nhà thông minh, UWB đang thay đổi cách chúng ta tương tác với thế giới xung quanh. Bạn đã sẵn sàng khám phá tiềm năng của UWB chưa? Hãy cùng ORBRO ứng dụng các công nghệ tiên tiến để theo kịp thời đại công nghệ nhé!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
    ],
  },
};
